import { gql } from '@apollo/client';
import client from 'apollo/client';

// Get rankings for a specific exercise
export const exerciseRankings = async ({ exerciseId, period = 'ALL_TIME', limit = 10 }) => {
  const response = await client.query({
    query: gql`
      query ExerciseRankings($exerciseId: ID!, $period: RankingPeriod, $limit: Int) {
        exerciseRankings(exercise_id: $exerciseId, period: $period, limit: $limit) {
          id
          user_id
          exercise_id
          best_value
          value_type
          rank
          period
          points
          medal
          formatted_value
          user {
            id
            first_name
            last_name
            full_name
            photo
          }
          exercise {
            id
            name
            localized_name
          }
        }
      }
    `,
    variables: { exerciseId, period, limit },
    fetchPolicy: 'network-only'
  });
  return response.data.exerciseRankings;
};

// Get podium (top 3) for a specific exercise
export const exercisePodium = async ({ exerciseId, period = 'ALL_TIME' }) => {
  const response = await client.query({
    query: gql`
      query ExercisePodium($exerciseId: ID!, $period: RankingPeriod) {
        exercisePodium(exercise_id: $exerciseId, period: $period) {
          first {
            id
            best_value
            formatted_value
            medal
            user {
              id
              first_name
              last_name
              full_name
              photo
            }
          }
          second {
            id
            best_value
            formatted_value
            medal
            user {
              id
              first_name
              last_name
              full_name
              photo
            }
          }
          third {
            id
            best_value
            formatted_value
            medal
            user {
              id
              first_name
              last_name
              full_name
              photo
            }
          }
        }
      }
    `,
    variables: { exerciseId, period },
    fetchPolicy: 'network-only'
  });
  return response.data.exercisePodium;
};

// Get my ranking for a specific exercise
export const myExerciseRanking = async ({ exerciseId, period = 'ALL_TIME' }) => {
  const response = await client.query({
    query: gql`
      query MyExerciseRanking($exerciseId: ID!, $period: RankingPeriod) {
        myExerciseRanking(exercise_id: $exerciseId, period: $period) {
          id
          best_value
          value_type
          rank
          period
          points
          medal
          formatted_value
          exercise {
            id
            name
            localized_name
          }
        }
      }
    `,
    variables: { exerciseId, period },
    fetchPolicy: 'network-only'
  });
  return response.data.myExerciseRanking;
};

// Get my rankings for all exercises
export const myRankings = async ({ period = 'ALL_TIME' }) => {
  const response = await client.query({
    query: gql`
      query MyRankings($period: RankingPeriod) {
        myRankings(period: $period) {
          id
          best_value
          value_type
          rank
          period
          points
          medal
          formatted_value
          exercise {
            id
            name
            localized_name
          }
        }
      }
    `,
    variables: { period },
    fetchPolicy: 'network-only'
  });
  return response.data.myRankings;
};

// Get my achievements
export const myAchievements = async ({ achievementType = null }) => {
  const response = await client.query({
    query: gql`
      query MyAchievements($achievementType: AchievementType) {
        myAchievements(achievement_type: $achievementType) {
          id
          achievement_type
          value
          achieved_at
          localized_name
          icon
          exercise {
            id
            name
            localized_name
          }
        }
      }
    `,
    variables: { achievementType },
    fetchPolicy: 'network-only'
  });
  return response.data.myAchievements;
};

// Get my streak
export const myStreak = async () => {
  const response = await client.query({
    query: gql`
      query MyStreak {
        myStreak {
          id
          current_streak
          longest_streak
          last_activity_date
          streak_start_date
          status
        }
      }
    `,
    fetchPolicy: 'network-only'
  });
  return response.data.myStreak;
};

// Get global leaderboard
export const leaderboard = async ({ period = 'ALL_TIME', limit = 20 }) => {
  const response = await client.query({
    query: gql`
      query Leaderboard($period: RankingPeriod, $limit: Int) {
        leaderboard(period: $period, limit: $limit) {
          user_id
          total_points
          global_rank
          total_users
          points_to_next_rank
        }
      }
    `,
    variables: { period, limit },
    fetchPolicy: 'network-only'
  });
  return response.data.leaderboard;
};

// Get my global ranking summary
export const myGlobalRankingSummary = async () => {
  const response = await client.query({
    query: gql`
      query MyGlobalRankingSummary {
        myGlobalRankingSummary {
          user_id
          total_points
          global_rank
          total_users
          points_to_next_rank
        }
      }
    `,
    fetchPolicy: 'network-only'
  });
  return response.data.myGlobalRankingSummary;
};
